/*
 * @Author: your name
 * @Date: 2020-02-18 18:47:15
 * @LastEditTime: 2020-02-20 10:15:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \merchant-ui-pc\src\services\query.js
 */
import request from '@/utils/request'

export function favoriteList (query) {
	return request({
		url: '/api/merchant/product-favorite/list',
		method: 'get',
		params: query
	})
}

export function myproductList (query) {
	return request({
		url: '/api/merchant/business/product/myproduct',
		method: 'get',
		params: query
	})
}

export function myapiList (query) {
	return request({
		url: '/api/merchant/business/product/myapi',
		method: 'get',
		params: query
	})
}

export function getStat24h (query) {
	return request({
		url: '/api/stat/record/stat24h/category-code',
		method: 'get',
		params: query
	})
}

export function getStat30d (query) {
	return request({
		url: '/api/stat/record/stat30d/category-code',
		method: 'get',
		params: query
	})
}

export function getStat6m (query) {
	return request({
		url: '/api/stat/record/stat6m/category-code',
		method: 'get',
		params: query
	})
}

export function getProductTree (query) {
	return request({
		url: '/api/merchant/business/product/api-tree',
		method: 'get',
		params: query
	})
}

export function getProductList (query) {
	return request({
		url: '/api/merchant/product-admin/list',
		method: 'get',
		params: query
	})
}

export function getProductDetail (query) {
	return request({
		url: '/api/merchant/product/detail',
		method: 'get',
		params: query
	})
}

export function getCategoryDoc (query) {
	return request({
		url: '/api/merchant/api-category-doc',
		method: 'get',
		params: query
	})
}

export function productAlert (query) {
	return request({
		url: '/api/merchant/business/product/alert',
		method: 'post',
		params: query
	})
}

// 商户会员权益
export function membersInfo (query) {
	return request({
		url: '/api/merchant/api-members/membersInfo',
		method: 'get',
		params: query
	})
}


// WEBPACK FOOTER //
// ./src/services/product.js